export const GET_TEMPLATES = "GET_TEMPLATES";
export const CREATE_TEMPLATES = "CREATE_TEMPLATES";
export const UPDATE_TEMPLATES = "UPDATE_TEMPLATES";
export const TEMPLATES_FAILURE = "TEMPLATES_FAILURE";
export const TEMPLATES_SUCCESS = "TEMPLATES_SUCCESS";
export const GET_CATEGORIES = "GET_CATEGORIES";
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
export const GET_CATEGORIES_FAILURE = "GET_CATEGORIES_FAILURE";
export const DELETE_TEMPLATE = "DELETE_TEMPLATE";
export const DELETE_TEMPLATE_SUCCESS = "DELETE_TEMPLATE_SUCCESS";
export const DELETE_TEMPLATE_FAILURE = "DELETE_TEMPLATE_FAILURE";

export const get_TemplateListings = (payload) => ({
  type: GET_TEMPLATES,
  payload,
});
export const create_listings = (payload) => ({
  type: CREATE_TEMPLATES,
  payload,
});

export const update_listings = (payload) => ({
  type: UPDATE_TEMPLATES,
  payload,
});
export const create_listings_fail = (payload) => ({
  type: TEMPLATES_FAILURE,
  payload,
});

export const create_listings_success = (payload) => ({
  type: TEMPLATES_SUCCESS,
  payload,
});

// get categories BYID
export const CategoriesGetByID = (payload) => ({
  type: GET_CATEGORIES,
  payload,
});

export const CategoriesGetByIDSuccess = (payload) => ({
  type: GET_CATEGORIES_SUCCESS,
  payload,
});
export const CategoriesGetByIDFailure = (payload) => ({
  type: GET_CATEGORIES_FAILURE,
  payload,
});

export const deleteTemplate = (payload) => ({
  type: DELETE_TEMPLATE,
  payload,
});
export const deleteTemplateSuccess = (payload) => ({
  type: DELETE_TEMPLATE_SUCCESS,
  payload,
});
export const deleteTemplateFailure = (payload) => ({
  type: DELETE_TEMPLATE_FAILURE,
  payload,
});
